import { GridComparatorFn, gridDateComparator } from '@mui/x-data-grid';

export const entityDueDateSortComparator = (
  v1: Date | null,
  v2: Date | null,
): number => {
  if (v1 === null) return 1;

  if (v2 === null) return -1;

  return new Date(v1).getTime() - new Date(v2).getTime();
};

export const dueDateSortComparator: GridComparatorFn = (
  v1,
  v2,
  param1,
  param2,
) => {
  let date1 = v1.split(',')[0];
  let date2 = v2.split(',')[0];

  date1 = date1 === 'null' ? new Date('1/1/2099') : new Date(date1);
  date2 = date2 === 'null' ? new Date('1/1/2099') : new Date(date2);

  return gridDateComparator(date1, date2, param1, param2);
};

const getNumberForSeverity = (severity: string): number => {
  switch (severity.toLowerCase()) {
    case 'zero-day': {
      return 0;
    }
    case 'immediate': {
      return 1;
    }
    case 'critical': {
      return 2;
    }
    case 'high': {
      return 3;
    }
    case 'medium': {
      return 4;
    }
    case 'low': {
      return 5;
    }
    default: {
      return 6;
    }
  }
};

export const severitySortComparator = (v1: string, v2: string): number => {
  const severity1 = getNumberForSeverity(v1);
  const severity2 = getNumberForSeverity(v2);

  return severity1 - severity2;
};
